import { render, staticRenderFns } from "./EmailTemplateContainer.vue?vue&type=template&id=6d5b2055&"
import script from "./EmailTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports